import React from 'react';
const IconArrowCodeDots = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M7.76982 6.75998L6.22982 5.47998L0.819824 12L6.22982 18.52L7.76982 17.24L3.41982 12L7.76982 6.75998ZM6.99982 13H8.99982V11H6.99982V13ZM14.9998 11H16.9998V13H14.9998V11ZM10.9998 13H12.9998V11H10.9998V13ZM16.2298 6.75998L17.7698 5.47998L23.1798 12L17.7698 18.52L16.2298 17.24L20.5798 12L16.2298 6.75998Z" fill="#666666"/>
</svg>
);
};
export default IconArrowCodeDots;